import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
    // root: {
    //     flexGrow: 1,
    //     width: '100%',
    //     backgroundColor: theme.palette.background.paper,
    // },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    expenditure: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    mt15: {
        marginTop: '15px !important',
    },
    btnGrey: {
        color: '#ccc !important',
        border: '1px solid #ccc !important',
        cursor: 'default',
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function TravelledOutsideIndia() {
    const classes = useStyles();
    // const [value, setValue] = React.useState(0);
    // const [provide, setprovide] = useState('none');
    const [available, setAvailable] = useState('Available');
    // const [lost, setLost] = useState('none');
    // const [formValues, setformValues] = React.useState({
    //     year: 'Select Year',
    //     daysIndia: 'Enter No. of Days',
    // });

    const handleChange = (event, newValue) => {
        // setValue(newValue);
    };

    // const handleRoleChange = (event) => {
    //     setAvailable(event.target.value);

    //     switch (event.target.value) {
    //         case 'available':
    //             setAvailable('block');
    //             // setprovide('none');
    //             // setLost('none');
    //             return true;
    //         case 'provide':
    //             // setprovide('block');
    //             setAvailable('none');
    //             // setLost('none');
    //             return true;
    //         case 'lost':
    //             // setLost('block');
    //             setAvailable('none');
    //             // setprovide('none');
    //             return true;
    //         default:
    //             return true;
    //     }
    // };

    // const [state, setState] = React.useState({
    //     2020: '',
    //     2021: '',
    //     2022: '',
    // });
    return (
        <Grid container spacing={3} className="main-container">
            <Grid item xs={12} sm={12}>
                <FormControl component="fieldset">
                    <RadioGroup defaultValue="yes" aria-label="yes-no" name="customized-radios" className="radio-option">
                        <ul className={classes.inlineDisplay}>
                            <li>
                                <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                            </li>
                            <li>
                                <FormControlLabel value="no" control={<StyledRadio />} disabled label="No" className="cursor-default" />
                            </li>
                        </ul>
                    </RadioGroup>
                </FormControl>

                <div style={{ display: available }}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth className={classes.margin}>
                                <InputLabel htmlFor="select-year">Select Year</InputLabel>
                                <Select
                                    disabled
                                    native
                                    // value={state.year}
                                    onChange={handleChange}
                                    inputProps={{
                                        name: 'Select Year',
                                        id: 'year',
                                    }}
                                    className={classes.bottomLine}
                                >
                                    <option aria-label="None" value="" />
                                    <option value={10}>2020</option>
                                    <option value={20}>2021</option>
                                    <option value={30}>2022</option>
                                </Select>
                                <Typography variant="caption" gutterBottom>
                                    In the above case, year represents April to March in each case
                                </Typography>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth className={classes.margin}>
                                <InputLabel htmlFor="No-of-days-india">No. of days stayed in India</InputLabel>
                                <Input
                                    disabled
                                    className={classes.bottomLine}
                                    id="No-of-days-india"
                                    // value={formValues.daysIndia}
                                    // onChange={handleChange('amount')}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </div>
                <div>
                    {/* <Button type="submit" className={classes.chekListAddBtn} title="Add Bank" /> */}
                    <Button variant="outlined" color="primary" className={clsx(classes.button, classes.btnGrey)}>
                        Add More
                    </Button>
                </div>
            </Grid>
        </Grid>
    );
}
